import React, {useEffect, useState} from 'react';
import {Header, StickySidebar} from './components/Header';
import PreloadAnimation from './components/PreloadAnimation';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Home from "./components/Home";
import Work from "./components/Work";
import About from "./components/About";
import Contact from "./components/Contact";
import Legal from "./components/Legal";
import FAQ from "./components/FAQ";

const AppContent: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false); // 'isOpen' state for sidebar
  const isFirstLoadRef = React.useRef(true);

  const menuItems = [
    { label: 'WORK', path: '/work' },
    { label: 'ABOUT', path: '/about' },
    // { label: 'STORE', path: '/store' },
    { label: 'CONTACT', path: '/contact' },
  ];
  const socialLinks = [
    { label: 'INSTAGRAM', url: 'https://www.instagram.com/laloxsolorio' },
    // Add more social links as needed
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen); // Toggle the sidebar
  };

  // Add navigation and location hooks
  const navigate = useNavigate();
  const location = useLocation();

  // Function to trigger preload animation
  const triggerPreload = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (location.pathname !== '/') {
        navigate('/');
      }
    }, 2500);
  };

  // Show preload animation only on initial page load
  useEffect(() => {
    if (isFirstLoadRef.current) {
      setLoading(true);
      const timer = setTimeout(() => {
        setLoading(false);
        isFirstLoadRef.current = false;
      }, 2500); // Adjust time based on animation duration
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    if (loading) {
      document.body.classList.add('noScrollPreload');
    } else {
      document.body.classList.remove('noScrollPreload');
    }
    return () => {
      document.body.classList.remove('noScrollPreload');
    };
  }, [loading]);

  return (
      <>
        {loading ? (
            <PreloadAnimation firstName="L A L O" lastName='S O L O R I O'/>
        ) : (
            <>
              <Header isOpen={isOpen} setIsOpen={setIsOpen} toggleMenu={toggleMenu} triggerPreload={triggerPreload} />
              <StickySidebar
                isOpen={isOpen}
                onSetOpen={setIsOpen}
                menuItems={menuItems}
                socialLinks={socialLinks}
              />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<Work />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/faq" element={<FAQ />} />
                {/* Update other Routes similarly */}
              </Routes>
            </>
        )}
      </>
  );
};

const App: React.FC = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;